<template>
    <div>
        <div :class="theme.stepperLabel">
            <span v-if="step !== undefined" :class="theme.step">{{step}}</span>
            <span v-else-if="icon !== undefined" :class="theme.icon">
                <v-font-icon :danger="danger">{{ icon }}</v-font-icon>
            </span>
            <div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
    import theme from './theme.scss';

    export default {
        name: 'stepper-label',
        props: {
            icon: String,
            step: [String, Number],
            danger: Boolean,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            },
        },
    }
</script>


// WEBPACK FOOTER //
// StepperLabel.vue?470d2707